@if (newsFeed !== '') {
  <ion-toolbar color="fri-violet">
    <ion-label rightToLeftAnimation [duration]="newsFeed.length * 130" [innerHTML]="newsFeed"> </ion-label>
  </ion-toolbar>
}
